import { Component } from "@angular/core";
import { config as CONFIG } from "app/app.config";

@Component({
    selector: "footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
    /**
     * Constructor
     */
    year: number;
    config = CONFIG;
    constructor() {
        this.year = new Date().getFullYear();
    }
}
